// @ts-check

const MOBILE_UA_REGEX = /iPhone|iPod|Windows Phone|Android.*Mobile/i;

/**
 * Detects whether the current device identifies as a mobile (phone-class) device.
 * Prefers the User-Agent Client Hints API where available (Chromium browsers),
 * falling back to a user-agent string match elsewhere (Safari, Firefox).
 *
 * Tablets are intentionally NOT considered mobile here, by design - this
 * answers "is this phone hardware," not "is this a touch/handheld device"
 * (see `isTouch` for that). This means an iPad, which defaults to a
 * desktop-Safari user agent with no Client Hints, correctly returns false.
 * @returns {boolean}
 */
const isMobile = () => {
  const nav = /** @type {Navigator & { userAgentData?: { mobile?: boolean } }} */ (navigator);

  if (nav.userAgentData && typeof nav.userAgentData.mobile === "boolean") {
    return nav.userAgentData.mobile;
  }

  return MOBILE_UA_REGEX.test(navigator.userAgent);
};

export default isMobile;
